import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { WandSparklesIcon } from "lucide-react";
import { GenerateTabs } from "@/components/ai-documents/generate-tabs";
import { RequestToolPrompt } from "@/components/ai-documents/request-tool-prompt";
import { companyQuery } from "@/lib/loaders";

/**
 * Generate landing. A "New document" tab lists the category-grouped catalog of
 * document types; "Bulk generate" fans a type across many recipients; "My
 * templates" lists the user's saved templates. The saved-documents library
 * lives separately at `/documents`.
 */
export const Route = createFileRoute("/_workspace/generate/")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(companyQuery),
  component: GeneratePage,
});

function GeneratePage() {
  const { tab } = Route.useSearch();
  const { data: company } = useQuery(companyQuery);
  const defaultTab = tab === "bulk" || tab === "templates" ? tab : "new";

  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <WandSparklesIcon className="size-3.5" />
            Generate
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Create a document</h1>
          <p className="text-muted-foreground text-sm">
            Generate HR documents — pre-filled from your employees and company profile. Pick a type
            or start from one of your templates.
          </p>
        </div>
        <GenerateTabs company={company ?? null} defaultTab={defaultTab} />
        <RequestToolPrompt />
      </div>
    </main>
  );
}
